import type { CollapseProps } from "antd";

import Info from "./DocumentInfo";
import DocumentFile from "./DocumentFile";
import CategoryDetail from "./CategoryInfo";

export const DocCategoryContentConstants = {
	INFO: "Doküman Bilgisi",
	DOC_FILE: "Dosya Bilgileri",
	CATEGORY: "Kategori Bilgisi",
};

export const DocCategoryItems: CollapseProps["items"] = [
	{
		key: "1",
		label: DocCategoryContentConstants.CATEGORY,
		children: <CategoryDetail />,
	},
	{
		key: "2",
		label: DocCategoryContentConstants.INFO,
		children: <Info />,
	},
	{
		key: "3",
		label: DocCategoryContentConstants.DOC_FILE,
		children: <DocumentFile />,
	}
];
